import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-10 max-w-4xl mx-auto">
      <button
        onClick={() => navigate(-1)}
        className="mb-6 inline-flex items-center gap-2 text-sm hover:opacity-80"
      >
        <ArrowLeft size={18} />
        <span>Back</span>
      </button>

      <header className="mb-8">
        <h1 className="text-3xl font-bold">Terms of Service</h1>
        <p className="text-sm text-gray-500 mt-2">Last updated: September 30, 2025</p>
      </header>

      <section className="space-y-6">
        <p>
          These Terms of Service ("Terms") govern your access to and use of Annotify and
          associated websites, browser extensions, and services (collectively, the "Service").
          By using the Service, you agree to be bound by these Terms.
        </p>

        <h2 className="text-xl font-semibold">1. Your Account</h2>
        <p>
          You are responsible for maintaining the confidentiality of your account and for all
          activities that occur under your account. You must provide accurate information and
          promptly update it as necessary.
        </p>

        <h2 className="text-xl font-semibold">2. Acceptable Use</h2>
        <p>
          You agree not to misuse the Service, including but not limited to: violating applicable
          laws, infringing intellectual property rights, uploading malicious code, scraping, or
          interfering with the security or operation of the Service.
        </p>

        <h2 className="text-xl font-semibold">3. Subscriptions and Billing</h2>
        <p>
          Paid features are offered via subscription processed by Paddle. By starting a
          subscription, you authorize Paddle to charge the applicable fees on a recurring basis
          until you cancel. Pricing and features are subject to change with notice.
        </p>

        <h2 className="text-xl font-semibold">4. Cancellations</h2>
        <p>
          You can cancel your subscription at any time effective at the end of your current
          billing period. You will retain access to paid features until the period ends.
        </p>

        <h2 className="text-xl font-semibold">5. Intellectual Property</h2>
        <p>
          The Service and its content, including software, text, graphics, and logos, are owned by
          or licensed to us and are protected by intellectual property laws. You may not copy,
          modify, distribute, or create derivative works without permission.
        </p>

        <h2 className="text-xl font-semibold">6. Privacy</h2>
        <p>
          Your use of the Service is subject to our Privacy Policy, which explains how we collect,
          use, and share your information.
        </p>

        <h2 className="text-xl font-semibold">7. Disclaimers</h2>
        <p>
          The Service is provided on an "as is" and "as available" basis without warranties of any
          kind, express or implied. We do not warrant that the Service will be uninterrupted,
          secure, or error-free.
        </p>

        <h2 className="text-xl font-semibold">8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, we will not be liable for any indirect,
          incidental, special, consequential, or punitive damages, or any loss of profits or
          revenues, whether incurred directly or indirectly, or any loss of data, use, or goodwill.
        </p>

        <h2 className="text-xl font-semibold">9. Changes to the Terms</h2>
        <p>
          We may update these Terms from time to time. We will post the updated Terms on this page
          with a new "Last updated" date. Your continued use of the Service constitutes acceptance
          of the updated Terms.
        </p>

        <h2 className="text-xl font-semibold">10. Contact</h2>
        <p>
          If you have questions about these Terms, contact us at <a className="text-club-accent" href="mailto:support@annotify.app">support@annotify.app</a>.
        </p>
      </section>

      <footer className="mt-10">
        <Link to="/" className="text-club-accent">Back to Home</Link>
      </footer>
    </div>
  );
}
